/**
 * TimelineRow JS
 * 
 * @param {HTMLElement} $ele
 * @return {Object}
 */
const TimelineRow = ($ele) => {
  /**
   * Init
   * 
   * @return {void}
   */
  const init = () => {
    $ele.classList.add('init');
    events();
  }

  /**
   * Events
   * 
   * @return {void}
   */
  const events = () => {
    window.addEventListener('scroll', onScroll);
  }

  /**
   * Check row is centered
   * 
   * @return {boolean}
   */
  const isCentered = () => {
    const rect = $ele.getBoundingClientRect();
    const viewHeight = window.innerHeight;
    return rect.top < viewHeight / 2 && rect.bottom > viewHeight / 2;
  }

  /**
   * Open the row
   * 
   * @return {void}
   */
  const open = () => {
    $ele.classList.add('open');
  }

  /**
   * Close the row
   * 
   * @return {void}
   */
  const close = () => {
    $ele.classList.remove('open');
  }

  /**
   * On scroll handler
   * 
   * @return {void}
   */
  const onScroll = () => {
    if (isCentered()) {
      open();
      window.removeEventListener('scroll', onScroll);
    }
  }

  init();
}

export default TimelineRow;